import { motion } from 'framer-motion';
import { Star, TrendingUp } from 'lucide-react';
import { NameData } from '../types';

interface PopularNamesProps {
  names: NameData[];
  onNameClick: (name: string) => void;
}

export default function PopularNames({ names, onNameClick }: PopularNamesProps) {
  const sortedNames = [...names]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 6);

  return (
    <section className="mb-12">
      <div className="flex items-center gap-2 mb-6">
        <TrendingUp className="text-purple-600" size={24} />
        <h2 className="text-2xl font-bold text-gray-900">Popular Names</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sortedNames.map((name, index) => (
          <motion.div
            key={name.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => onNameClick(name.name)}
            className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-4 cursor-pointer hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{name.name}</h3>
                <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                  {name.nepali_meaning}
                </p>
              </div>
              <div className="flex items-center gap-1 bg-white px-2 py-1 rounded-full">
                <Star size={14} className="text-yellow-500" />
                <span className="text-sm font-medium text-gray-700">
                  {name.popularity}%
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}